import { List, OrderedMap, Set } from 'immutable';
import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';

import { toggleItem } from './actions';
import { State } from './reducer';
import Tree from './Tree';

type Values = { [key: string]: any } | any[];

const sortValues = memoizeOne((values: Values) => {
	if (Array.isArray(values)) {
		return List(values)
			.toOrderedMap()
			.reduce((aggregator, value, key) => aggregator.set(String(key), value), OrderedMap<string, any>());
	}

	return OrderedMap<string, any>(values as Iterable<[string, any]>).sortBy(
		(value, key) => ({ key, value }),
		(a, b) => {
			const diff = valueIndex(a.value) - valueIndex(b.value);
			return diff === 0 ? a.key.localeCompare(b.key) : diff;
		}
	);
});

function valueIndex(value: null | boolean | string | number | any[]): number {
	if (value === null) {
		return 6;
	}
	if (value === true) {
		return 0;
	}
	if (value === false) {
		return 1;
	}
	if (typeof value === 'string') {
		return 2;
	}
	if (typeof value === 'number') {
		return 3;
	}
	if (!Array.isArray(value)) {
		return 4;
	}
	return 5;
}

function mapStateToProps(state: { treeBrowser: State }, props: { path: List<string>; values: Values }) {
	return {
		collapseKeys: state.treeBrowser.collapsePaths.get(props.path, Set()),
		values: sortValues(props.values),
	};
}

const actions = {
	onToggleItem: toggleItem,
};

export default connect(mapStateToProps, actions)(Tree);
